<template>
  <div class="prenota-tavolo-container">
    <div class="booking-card">
      <h1 class="title">{{ $t('prenota_tavolo') }}</h1>
      
      <!-- Step 1: Selezione Sala -->
      <div v-if="step === 1" class="step-container">
        <h3>1. {{ $t('seleziona_sala') }}</h3>
        <div class="sala-grid">
          <div 
            v-for="sala in sale" 
            :key="sala.nome" 
            class="sala-card"
            :class="{ active: form.codicesala === sala.nome }"
            @click="selectSala(sala.nome)"
          >
            <i class="fas fa-door-open"></i>
            <span>{{ sala.nome }}</span>
          </div>
        </div>
        <button v-if="form.codicesala" class="next-btn" @click="step = 2">Avanti</button>
      </div>

      <!-- Step 2: Dati Prenotazione -->
      <div v-if="step === 2" class="step-container">
        <button class="back-link" @click="step = 1"><i class="fas fa-arrow-left"></i> Indietro</button>
        <h3>2. {{ $t('dati_prenotazione') }}</h3>
        <form @submit.prevent="submitBooking" class="booking-form">
          <div class="form-group">
            <label>{{ $t('nome') }}</label>
            <input v-model="form.nome" required type="text" placeholder="Nome">
          </div>
          <div class="form-group">
            <label>{{ $t('cognome') }}</label>
            <input v-model="form.cognome" required type="text" placeholder="Cognome">
          </div>
          <div class="form-group">
            <label>{{ $t('telefono') }}</label>
            <input v-model="form.telefono" required type="tel" placeholder="Telefono">
          </div>
          <div class="form-group">
            <label>Email</label>
            <input v-model="form.email" required type="email" placeholder="Email">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('nr_coperti') }}</label>
              <input v-model.number="form.coperti" required type="number" min="1">
            </div>
            <div class="form-group">
              <label>{{ $t('data') }}</label>
              <input v-model="form.data" required type="date" :min="today">
            </div>
            <div class="form-group">
              <label>{{ $t('ora') }}</label>
              <input v-model="form.ora" required type="time" @change="validateTime">
              <small v-if="selectedSalaObj" class="time-hint">
                <span v-if="selectedSalaObj.pranzoStart || selectedSalaObj.cenaStart">Orari: </span>
                <span v-if="selectedSalaObj.pranzoStart">{{ selectedSalaObj.pranzoStart }} - {{ selectedSalaObj.pranzoEnd }}</span>
                <span v-if="selectedSalaObj.pranzoStart && selectedSalaObj.cenaStart"> | </span>
                <span v-if="selectedSalaObj.cenaStart">{{ selectedSalaObj.cenaStart }} - {{ selectedSalaObj.cenaEnd }}</span>
              </small>
            </div>
          </div>
          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="!loading">{{ $t('conferma_prenotazione') }}</span>
            <span v-else>Invio in corso...</span>
          </button>
        </form>
      </div>

      <!-- Success Result -->
      <div v-if="step === 3" class="success-container">
        <i class="fas fa-check-circle success-icon"></i>
        <p>{{ $t('prenotazione_successo') }}</p>
        <button class="home-btn" @click="goHome">Torna alla Home</button>
      </div>

      <div v-if="error" class="error-msg">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'PrenotaTavolo',
  data() {
    return {
      step: 1,
      loading: false,
      error: '',
      sale: [],
      today: new Date().toISOString().split('T')[0],
      form: {
        codicesala: '',
        nome: '',
        cognome: '',
        telefono: '',
        email: '',
        coperti: 2,
        data: '',
        ora: ''
      },
      store
    }
  },
  computed: {
    selectedSalaObj() {
      return this.sale.find(s => s.nome === this.form.codicesala)
    }
  },
  methods: {
    fetchSale() {
      this.axios.get(this.store.path + 'prenotazioni/sale').then(res => {
        this.sale = res.data
      }).catch(err => {
        console.error("Error fetching sale:", err)
      })
    },
    selectSala(nome) {
      this.form.codicesala = nome
      this.form.ora = '' // Reset time when changing room
      this.error = ''
    },
    validateTime() {
      if (!this.form.ora || !this.selectedSalaObj) return true;
      
      const s = this.selectedSalaObj;
      const ora = this.form.ora;
      let isValid = false;
      
      if (s.pranzoStart && s.pranzoEnd && ora >= s.pranzoStart && ora <= s.pranzoEnd) {
        isValid = true;
      } else if (s.cenaStart && s.cenaEnd && ora >= s.cenaStart && ora <= s.cenaEnd) {
        isValid = true;
      }
      
      if (!isValid && (s.pranzoStart || s.cenaStart)) {
        this.error = 'L\'orario selezionato non è disponibile per questa sala. Scegli un orario tra quelli indicati.';
        return false;
      }
      
      this.error = '';
      return true;
    },
    submitBooking() {
      if (!this.validateTime()) return;
      
      this.loading = true
      this.error = ''
      this.axios.post(this.store.path + 'prenotazioni', this.form)
        .then(() => {
          this.step = 3
        })
        .catch(err => {
          this.error = err.response ? err.response.data.message : 'Errore durante la prenotazione'
        })
        .finally(() => {
          this.loading = false
        })
    },
    goHome() {
      this.$router.push('/client')
    }
  },
  mounted() {
    this.fetchSale()
  }
}
</script>

<style scoped>
.prenota-tavolo-container {
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.booking-card {
  background: white;
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  padding: 40px;
}

.title { text-align: center; color: #333; margin-bottom: 30px; }

.step-container h3 { margin-bottom: 20px; color: #666; }

.sala-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 25px;
}

.sala-card {
  border: 2px solid #eee;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sala-card.active {
  border-color: #4CAF50;
  background: #f1f8f1;
  color: #4CAF50;
}

.sala-card i { font-size: 24px; }

.next-btn, .submit-btn, .home-btn {
  width: 100%;
  padding: 15px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
}

.submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }

.back-link {
  background: none;
  border: none;
  color: #666;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.booking-form { display: flex; flex-direction: column; gap: 15px; }

.form-group { display: flex; flex-direction: column; gap: 5px; }

.form-group label { font-size: 0.9rem; color: #666; }

.form-group input {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
}

.form-row { display: grid; grid-template-columns: 1fr 2fr 1.5fr; gap: 10px; }

.success-container { text-align: center; }

.success-icon { font-size: 60px; color: #4CAF50; margin-bottom: 20px; }

.error-msg {
  margin-top: 20px;
  padding: 15px;
  background: #ffebee;
  color: #c62828;
  border-radius: 8px;
  text-align: center;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .booking-card {
    padding: 20px;
    border-radius: 12px;
  }

  .sala-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  .time-hint {
    font-size: 0.75rem;
  }
}
</style>
